module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/sns_3-f34bd0b049b95ea81bcc6f65b997000e.png";